import {AES, enc} from 'crypto-ts';
import {environment} from '@shared/config/environment';
import {PARAMS_KEY} from 'src/routes/BaseRoute';
class EncryptUtils {
  static setEncryptedParams = (
    data: Record<string, string | undefined | number>
  ): string => {
    return encodeURIComponent(
      AES.encrypt(JSON.stringify(data), environment.encryptURLKey).toString()
    );
  };

  static encryptedData = (
    data: Record<string, string | undefined | number | boolean | object | null>
  ): string => {
    return AES.encrypt(
      JSON.stringify(data),
      environment.encryptDataKey
    ).toString();
  };

  static getDecryptedParams = (
    tokenString: string | null
  ): Record<string, string | undefined> => {
    if (tokenString) {
      try {
        const dataString = AES.decrypt(
          decodeURIComponent(tokenString),
          environment.encryptURLKey
        );
        return JSON.parse(dataString.toString(enc.Utf8));
      } catch (error) {
        console.error('Error during decryption:', error);
        return {};
      }
    }
    return {};
  };
  static getDecryptedData = (location: any, paramKey: string): string => {
    const urlParam = new URLSearchParams(location).get(PARAMS_KEY);
    const paramsData = EncryptUtils.getDecryptedParams(urlParam);
    const value = paramsData?.[paramKey] || '';
    return value;
  };
}

export default EncryptUtils;

